import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPowerPlant: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPowerPlant"><Path d="M8.75064 5.25C8.75064 4.55964 9.31029 4 10.0006 4H20.0006V2.5H10.0006C8.48186 2.5 7.25064 3.73122 7.25064 5.25V6H8.75064V5.25Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M10.8902 7H5.11109L2.87109 21L21.0006 21.0001V10.3122L15.7506 12.8122V10.2974L11.7328 12.2661L10.8902 7ZM4.63017 19.5L6.39017 8.5H9.61109L11.3711 19.5H4.63017Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPowerPlant;
